export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14205.604f7f88.jpg";